import React from 'react';

import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import { formatDayToYearWithTime } from 'utils/date/format.util';

import { filterOutHey } from 'clientProfile/utils';

const MAX_SMS_COUNT = 80;

// TODO: convert to func component with module css

class ConversationDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedSent: [],
      expandedReceived: [],
    };
  }

  expandedSentText = (ind) => {
    const { expandedSent } = this.state;
    expandedSent[ind] = !expandedSent[ind];
    this.setState({ expandedSent });
  };
  expandedReceivedText = (ind) => {
    const { expandedReceived } = this.state;
    expandedReceived[ind] = !expandedReceived[ind];
    this.setState({ expandedReceived });
  };

  render() {
    let sentSMSs;
    let receivedSMSs;
    if (this.props.smsRecords && this.props.smsRecords.length) {
      sentSMSs = filterOutHey(this.props.smsRecords, 'sent');
      if (sentSMSs.length > 0) {
        const expandedSent = [];
        for (let i = 0; i < sentSMSs.length; i += 1) {
          expandedSent.push(false);
        }
      }
      if (this.props.smsRecords && this.props.smsRecords.length > 0) {
        receivedSMSs = filterOutHey(this.props.smsRecords, 'received');
      }
    }

    return (
      <React.Fragment>
        <div className="additional-i">
          {this.props.showTitle &&
            (this.props.notes || (sentSMSs && sentSMSs.length > 0) || (receivedSMSs && receivedSMSs.length > 0)) && (
              <h3>Additional booking details</h3>
            )}
          {this.props.notes && (
            <div className="bh-block border-b">
              <p> Booking Note</p>
              <div style={{ color: '#acacac' }}>{this.props.notes}</div>
            </div>
          )}
          {fromAnyToBool(sentSMSs?.length === 0 && receivedSMSs?.length === 0 && this.props.smsRemindersOn) && (
            <div className="bh-block border-b">
              <div style={{ color: '#acacac' }}>SMS Reminders and client replies will appear here</div>
            </div>
          )}

          {sentSMSs &&
            sentSMSs.length > 0 &&
            sentSMSs.map((sentSMS, index) => {
              const moreThanOneLineSent = sentSMS.text.length >= MAX_SMS_COUNT;
              return (
                <div className="bh-block border-b">
                  <p style={{ minHeight: '18px' }}>
                    <span>SMS sent </span> <small>{formatDayToYearWithTime(sentSMS.timestamp)}</small>
                  </p>
                  <div
                    className={this.state.expandedSent[index] ? 'expandable-container open' : 'expandable-container'}
                  >
                    <span className={this.state.expandedSent[index] ? 'sms-text' : 'sms-text clip'}>
                      {sentSMS.text}
                    </span>
                    {moreThanOneLineSent ? (
                      <span
                        role="button"
                        tabIndex={0}
                        className="show-more-text"
                        onClick={() => this.expandedSentText(index)}
                      >
                        {this.state.expandedSent[index] ? '...view less' : '...view more'}
                      </span>
                    ) : (
                      <div />
                    )}
                  </div>
                </div>
              );
            })}

          {receivedSMSs &&
            receivedSMSs.length > 0 &&
            receivedSMSs.map((receivedSMS, index) => {
              const moreThanOneLineReceived = receivedSMS.text.length > MAX_SMS_COUNT;

              return (
                <div className="bh-block border-b">
                  <p style={{ minHeight: '18px' }}>
                    <span>Client reply </span> <small>{formatDayToYearWithTime(receivedSMS.timestamp)}</small>
                  </p>
                  <div
                    className={
                      this.state.expandedReceived[index] ? 'expandable-container open' : 'expandable-container'
                    }
                  >
                    <span className={this.state.expandedReceived[index] ? 'sms-text' : 'sms-text clip'}>
                      {receivedSMS.text}
                    </span>
                    {moreThanOneLineReceived ? (
                      <span
                        role="button"
                        tabIndex={0}
                        className="show-more-text"
                        onClick={() => this.expandedReceivedText(index)}
                      >
                        {this.state.expandedReceived[index] ? '...view less' : '...view more'}
                      </span>
                    ) : (
                      <div />
                    )}
                  </div>
                </div>
              );
            })}

          {sentSMSs && sentSMSs.length > 0 && receivedSMSs && receivedSMSs.length === 0 && (
            <p className="empty-message"> Client hasn't replied</p>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default ConversationDetails;
